var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skill-plan"},[_c('SkillDivePlanDetails',_vm._b({on:{"show-session-details-clicked":_vm.handleShowSessionDetailsClick}},'SkillDivePlanDetails',{
      isPlanActive: _vm.isPlanActive,
      isPlanFailed: _vm.isPlanFailed,
      isPlanInCancelledState: _vm.isPlanInCancelledState,
      isPlanPending: _vm.isPlanPending,
      planExpiryDate: _vm.planExpiryDate,
      planHasProvider: _vm.planHasProvider,
      daysRemainingForSub: _vm.daysRemainingForSub,
      labExperienceUserAccess: _vm.labExperienceUserAccess,
    },false)),(_vm.showSessionDetails)?_c('SkillDivePlanSessionDetails'):_vm._e(),(_vm.canViewPlanActions)?_c('SkillDivePlanActions',_vm._b({on:{"cancel-renewal-clicked":_vm.handleCancelRenewalClick,"reactivate-renewal-clicked":_vm.handleReactivateRenewalClick,"manage-skill-dive-clicked":function($event){return _vm.$emit('manage-skill-dive-clicked')}}},'SkillDivePlanActions',{
      isLoading: _vm.isLoading,
      validAddons: _vm.validAddons,
      isPlanActive: _vm.isPlanActive,
      isPlanInCancelledState: _vm.isPlanInCancelledState,
      planExpiryDate: _vm.planExpiryDate,
    },false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }